import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TitlePrevCarouselArrow = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                stroke: color || "#DCDFEC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.2929 28.7071C13.9024 28.3166 13.9024 27.6834 14.2929 27.2929L20.6569 20.9289C21.0474 20.5384 21.6805 20.5384 22.0711 20.9289C22.4616 21.3195 22.4616 21.9526 22.0711 22.3431L16.4142 28L22.0711 33.6569C22.4616 34.0474 22.4616 34.6805 22.0711 35.0711C21.6805 35.4616 21.0474 35.4616 20.6569 35.0711L14.2929 28.7071ZM41 29H15V27H41V29Z",
                fill: color || "white"
            })
        ]
    });
